import React from 'react';
import './App.css';
import GameRouter from './components/GameRouter';

function App() {
  return (
    <div className="App">
      <GameRouter />
    </div>
  );
}

export default App;
